(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["osiris-ring-builder"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.getElementById('OsirisRingBuilder');
    if (!root) return;

    const configNode = root.querySelector('[data-osiris-builder-config]');
    const config = JSON.parse(configNode.textContent);
    const storageKey = 'osiris_ring_builder_v1';
    const progress = root.querySelector('[data-osiris-builder-progress]');
    const dialog = root.querySelector('[data-osiris-builder-dialog]');
    const dialogContent = root.querySelector('[data-osiris-builder-dialog-content]');
    const status = root.querySelector('[data-osiris-builder-status]');
    const isRingProduct = root.dataset.ringProduct === 'true';
    const isDiamondPage = root.dataset.diamondPage === 'true';
    const isFancyDiamondPage = isDiamondPage && config.diamondCollection === 'fancy';
    const isRingCollection = root.dataset.ringCollection === 'true';
    const isCartPage = root.dataset.cartPage === 'true';
    const shapeNames = ['round', 'oval', 'pear', 'emerald', 'princess', 'cushion', 'radiant', 'marquise', 'asscher', 'heart'];

    const readState = () => {
      try {
        return JSON.parse(sessionStorage.getItem(storageKey)) || {};
      } catch {
        return {};
      }
    };

    const writeState = (state) => {
      sessionStorage.setItem(storageKey, JSON.stringify(state));
    };

    const clearState = () => {
      sessionStorage.removeItem(storageKey);
    };

    const inferShape = (value) => {
      const source = String(value || '').toLowerCase();
      return shapeNames.find((shape) => source.includes(shape)) || '';
    };

    const escapeHtml = (value) => {
      const element = document.createElement('div');
      element.textContent = String(value || '');
      return element.innerHTML;
    };

    const report = (message) => {
      status.textContent = message;
      window.setTimeout(() => {
        if (status.textContent === message) status.textContent = '';
      }, 6000);
    };

    const currentState = () => {
      const state = readState();
      if (!state.start) {
        if (isRingProduct || isRingCollection) state.start = 'setting';
        if (isDiamondPage) state.start = 'diamond';
      }
      return state;
    };

    const diamondRoute = (shape) => {
      const state = readState();
      const isFancy = state.diamondCollection === 'fancy';
      const route = isFancy ? config.routes.coloredDiamond : state.diamondType === 'natural' ? config.routes.naturalDiamond : config.routes.diamond;
      const target = new URL(route, location.origin);
      if (isFancy) {
        target.search = state.diamondSearch || '';
        const isLab = state.diamondType !== 'natural';
        target.searchParams.set('activeTab', isLab ? 'Lab Grown' : 'Natural');
        target.searchParams.set('queryLabGrown', String(isLab));
      }
      if (shape) target.searchParams.set('shapes', shape);
      target.searchParams.set('builder', 'setting');
      return target.pathname + target.search;
    };

    const rememberFancySearch = () => {
      if (!isFancyDiamondPage) return false;
      const params = new URLSearchParams(location.search);
      const state = readState();
      if (params.has('id') && state.diamondCollection === 'fancy' && state.diamondSearch) return false;
      ['id', 'stoneType', 'builder', 'preview_theme_id', '_fd', 'pb'].forEach((key) => params.delete(key));
      const activeTab = document.querySelector('#nat-lab-toggle .nat-lab-item-active');
      const isLab = activeTab ? /lab/i.test(activeTab.textContent) : params.get('queryLabGrown') === 'true' || /lab/i.test(params.get('activeTab') || '');
      params.set('activeTab', isLab ? 'Lab Grown' : 'Natural');
      params.set('queryLabGrown', String(isLab));
      const diamondType = isLab ? 'lab' : 'natural';
      const diamondSearch = params.toString();
      if (state.diamondCollection === 'fancy' && state.diamondType === diamondType && state.diamondSearch === diamondSearch) return false;
      state.diamondCollection = 'fancy';
      state.diamondType = diamondType;
      state.diamondSearch = diamondSearch;
      writeState(state);
      return true;
    };

    const ringRoute = () => config.routes.rings + '?builder=diamond';

    const renderProgress = () => {
      const state = currentState();
      const shouldShow = isRingProduct || isDiamondPage || isRingCollection || (isCartPage && (state.setting || state.diamond));
      if (!shouldShow) {
        progress.hidden = true;
        progress.innerHTML = '';
        return;
      }

      const firstIsSetting = state.start !== 'diamond';
      const firstItem = firstIsSetting ? state.setting : state.diamond;
      const secondItem = firstIsSetting ? state.diamond : state.setting;
      const firstLabel = firstIsSetting ? config.text.chooseSetting : config.text.chooseDiamond;
      const secondLabel = firstIsSetting ? config.text.chooseDiamond : config.text.chooseSetting;
      const firstMobileLabel = firstIsSetting ? config.text.chooseSettingShort : config.text.chooseDiamondShort;
      const secondMobileLabel = firstIsSetting ? config.text.chooseDiamondShort : config.text.chooseSettingShort;
      const firstTitle = firstItem && firstItem.title ? firstItem.title : firstLabel;
      const secondTitle = secondItem && secondItem.title ? secondItem.title : secondLabel;
      const stepThreeComplete = Boolean(state.setting && state.diamond);
      const firstKind = firstIsSetting ? 'setting' : 'diamond';
      const secondKind = firstIsSetting ? 'diamond' : 'setting';
      const stepLink = (kind) => {
        if (kind === 'setting') return ringRoute();
        return diamondRoute(state.setting && state.setting.shape);
      };
      const steps = [
        {
          label: firstTitle,
          mobileLabel: firstItem ? (firstKind === 'setting' ? config.text.settingSelected : config.text.diamondSelected) : firstMobileLabel,
          complete: Boolean(firstItem),
          active: !firstItem,
          href: stepLink(firstKind)
        },
        {
          label: secondTitle,
          mobileLabel: secondItem ? (secondKind === 'setting' ? config.text.settingSelected : config.text.diamondSelected) : secondMobileLabel,
          complete: Boolean(secondItem),
          active: Boolean(firstItem && !secondItem),
          href: stepLink(secondKind)
        },
        {
          label: config.text.completeRing,
          mobileLabel: config.text.completeRing,
          complete: stepThreeComplete,
          active: stepThreeComplete
        }
      ];

      const stepMarkup = steps.map((step, index) => {
        const stateClass = step.complete ? ' is-complete' : step.active ? ' is-active' : '';
        const tag = step.active && step.href ? 'a' : 'div';
        const href = tag === 'a' ? ' href="' + escapeHtml(step.href) + '"' : '';
        return '<' + tag + ' class="osiris-builder__step' + stateClass + '"' + href + '>' +
          '<span class="osiris-builder__number">' + (step.complete ? '✓' : index + 1) + '</span>' +
          '<span class="osiris-builder__step-copy">' +
          '<span class="osiris-builder__label osiris-builder__label--desktop">' + escapeHtml(step.label) + '</span>' +
          '<span class="osiris-builder__label osiris-builder__label--mobile">' + escapeHtml(step.mobileLabel) + '</span>' +
          '</span></' + tag + '>';
      }).join('');

      progress.innerHTML = '<span class="osiris-builder__progress-title">' + escapeHtml(config.text.build) + '</span>' +
        '<div class="osiris-builder__steps">' + stepMarkup + '</div>';

      const main = document.querySelector('#MainContent') || document.querySelector('main');
      if (main && progress.parentElement !== main) main.prepend(progress);
      progress.hidden = false;
      root.hidden = false;
    };

    const setQuarterSizes = () => {
      const select = document.querySelector('select[name="properties[Ring Size]"]');
      if (!select || select.dataset.osirisQuarterSizes === 'true') return;
      const selected = select.value;
      const placeholder = select.querySelector('option[value=""]');
      select.innerHTML = '';
      if (placeholder) select.append(placeholder);
      for (let value = 4; value <= 11; value += 0.25) {
        const option = document.createElement('option');
        option.value = String(value);
        option.textContent = String(value);
        select.append(option);
      }
      if (selected) select.value = selected;
      select.dataset.osirisQuarterSizes = 'true';
    };

    const waitForSettingAdd = (variantId) => new Promise((resolve, reject) => {
      let finished = false;
      const verify = async () => {
        try {
          const response = await fetch((window.Shopify && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin' });
          const cart = await response.json();
          const found = cart.items.some((item) => String(item.variant_id) === String(variantId));
          if (found && !finished) {
            finished = true;
            resolve();
          }
        } catch {
          if (!finished) reject(new Error(config.text.settingAddFailed));
        }
      };

      if (window.eventBus && typeof window.eventBus.on === 'function') {
        window.eventBus.on('cart:added', verify);
      }

      const interval = window.setInterval(async () => {
        await verify();
        if (finished) window.clearInterval(interval);
      }, 700);

      window.setTimeout(() => {
        window.clearInterval(interval);
        if (!finished) {
          finished = true;
          reject(new Error(config.text.settingAddFailed));
        }
      }, 12000);
    });

    const syncRingSizePurchaseState = (wrapper, nativeButton, sizeSelect) => {
      const sizeMissing = !sizeSelect || !sizeSelect.value;
      const chooseButton = wrapper.querySelector('[data-osiris-choose-diamond]');
      const acceleratedCheckout = wrapper.querySelector('.shopify-payment-button');
      const acceleratedCheckoutWrapper = wrapper.querySelector('[data-update-id="dynamic-checkout-buy_buttons"]');

      if (chooseButton) chooseButton.disabled = false;

      if (acceleratedCheckout) {
        acceleratedCheckout.hidden = sizeMissing;
        acceleratedCheckout.setAttribute('aria-hidden', String(sizeMissing));
      }

      if (acceleratedCheckoutWrapper) {
        acceleratedCheckoutWrapper.classList.toggle('osiris-builder__checkout-disabled', sizeMissing);
        acceleratedCheckoutWrapper.setAttribute('aria-hidden', String(sizeMissing));
      }
    };

    const setupRingProduct = () => {
      setQuarterSizes();
      const wrapper = document.querySelector('.paymentButtonsWrapper');
      const nativeButton = wrapper && wrapper.querySelector('.product--add-to-cart-button');
      const form = nativeButton && nativeButton.closest('form');
      const sizeSelect = document.querySelector('select[name="properties[Ring Size]"]');
      if (!wrapper || !nativeButton || !form || !sizeSelect) return;

      if (wrapper.querySelector('[data-osiris-choose-diamond]')) {
        syncRingSizePurchaseState(wrapper, nativeButton, sizeSelect);
        return;
      }

      const state = currentState();
      const nativeText = nativeButton.querySelector('[data-add-to-cart-text]');
      if (nativeText) nativeText.textContent = config.text.buySettingOnly;
      sizeSelect.required = true;

      const showRingSizeError = () => {
        const sizeField = sizeSelect.closest('.ck-ring-size');
        if (sizeField) sizeField.classList.add('osiris-builder__ring-size-error');
        report(config.text.selectRingSize);
        sizeSelect.focus();
        sizeSelect.reportValidity();
      };

      const actions = document.createElement('div');
      actions.className = 'osiris-builder__actions';
      actions.innerHTML =
        '<button class="btn osiris-builder__primary" type="button" data-osiris-choose-diamond>' +
        escapeHtml(state.diamond ? config.text.completeRing : config.text.selectSetting) +
        '</button>' +
        '<p class="osiris-builder__note">' + escapeHtml(state.diamond ? config.text.completeSettingMessage : config.text.compatibility) + '</p>';
      wrapper.prepend(actions);

      form.addEventListener('submit', (event) => {
        if (sizeSelect.value) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        showRingSizeError();
      }, true);

      sizeSelect.addEventListener('change', () => {
        const sizeField = sizeSelect.closest('.ck-ring-size');
        if (sizeField) sizeField.classList.remove('osiris-builder__ring-size-error');
        syncRingSizePurchaseState(wrapper, nativeButton, sizeSelect);
      });

      syncRingSizePurchaseState(wrapper, nativeButton, sizeSelect);

      actions.querySelector('[data-osiris-choose-diamond]').addEventListener('click', async (event) => {
        const button = event.currentTarget;
        if (sizeSelect && !sizeSelect.value) {
          showRingSizeError();
          return;
        }

        const variantInput = form.querySelector('[name="id"]');
        const variantId = variantInput && variantInput.value;
        if (!variantId || nativeButton.disabled) {
          report(config.text.selectRingSize);
          return;
        }

        const nextState = currentState();
        nextState.start = nextState.start || 'setting';
        nextState.setting = {
          title: config.product.title,
          url: config.product.url,
          image: config.product.image,
          shape: inferShape(config.product.title + ' ' + config.product.url),
          variantId,
          ringSize: sizeSelect ? sizeSelect.value : ''
        };
        writeState(nextState);
        renderProgress();

        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        const added = waitForSettingAdd(variantId);
        nativeButton.click();

        try {
          await added;
          if (nextState.diamond) {
            location.assign(config.routes.cart);
          } else {
            location.assign(diamondRoute(nextState.setting.shape));
          }
        } catch (error) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          report(error.message || config.text.settingAddFailed);
        }
      });
    };

    let cartBeforePointerDown = null;

    const fetchCart = async () => {
      const response = await fetch((window.Shopify && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin' });
      if (!response.ok) throw new Error(config.text.diamondAddFailed);
      return response.json();
    };

    const normalizedTitle = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

    const itemMatchesSelection = (item, selection) => {
      if (!selection) return false;
      if (selection.key && item.key === selection.key) return true;
      if (selection.variantId && String(item.variant_id) === String(selection.variantId)) return true;
      if (selection.url && item.url && (item.url.startsWith(selection.url) || selection.url.startsWith(item.url.split('?')[0]))) return true;
      const itemTitle = normalizedTitle(item.product_title || item.title);
      const selectedTitle = normalizedTitle(selection.title);
      return Boolean(selectedTitle && (itemTitle.includes(selectedTitle) || selectedTitle.includes(itemTitle)));
    };

    const syncStateWithCart = async () => {
      const beforeState = readState();
      if (!beforeState.setting && !beforeState.diamond) return false;
      const cart = await fetchCart();
      const state = { ...beforeState };

      if (state.setting && !cart.items.some((item) => itemMatchesSelection(item, state.setting))) {
        delete state.setting;
      }

      if (state.diamond && !cart.items.some((item) => itemMatchesSelection(item, state.diamond))) {
        delete state.diamond;
      }

      if (!state.setting && !state.diamond) {
        clearState();
      } else {
        writeState(state);
      }

      return JSON.stringify(beforeState) !== JSON.stringify(state);
    };

    const getDiamondData = () => {
      const app = document.querySelector('[id*="nivoda_connect_feed"]') || document.body;
      const headings = Array.from(app.querySelectorAll('h1, h2, h3'));
      const titleNode = headings.find((node) => /ct\b/i.test(node.textContent) && /diamond/i.test(node.textContent)) || headings[0];
      const title = titleNode ? titleNode.textContent.trim() : config.text.diamondSelected;
      const pageText = app.innerText || '';
      const priceMatch = pageText.match(/[$£€]\s?[\d,]+(?:\.\d{2})?/);
      const params = new URLSearchParams(location.search);
      return {
        id: params.get('id') || '',
        title,
        url: location.pathname + location.search,
        shape: inferShape(title),
        price: priceMatch ? priceMatch[0] : ''
      };
    };

    const openDiamondDialog = (state) => {
      if (state.setting) {
        dialogContent.innerHTML =
          '<div class="osiris-builder__dialog-inner">' +
          '<h2 id="OsirisBuilderDialogTitle">' + escapeHtml(config.text.ringComplete) + '</h2>' +
          '<p>' + escapeHtml(config.text.compatibility) + '</p>' +
          '<button class="osiris-builder__choice is-primary" type="button" data-builder-view-cart>' + escapeHtml(config.text.viewCart) + '<span aria-hidden="true">→</span></button>' +
          '<button class="osiris-builder__choice" type="button" data-builder-continue>' + escapeHtml(config.text.continueShopping) + '</button>' +
          '</div>';
      } else {
        dialogContent.innerHTML =
          '<div class="osiris-builder__dialog-inner">' +
          '<h2 id="OsirisBuilderDialogTitle">' + escapeHtml(config.text.addDiamondTo) + '</h2>' +
          '<p>' + escapeHtml(config.text.compatibility) + '</p>' +
          '<button class="osiris-builder__choice is-primary" type="button" data-builder-choose-setting>' + escapeHtml(config.text.chooseSetting) + '<span aria-hidden="true">→</span></button>' +
          '<button class="osiris-builder__choice" type="button" data-builder-diamond-only>' + escapeHtml(config.text.buyDiamondOnly) + '</button>' +
          '</div>';
      }

      const settingButton = dialogContent.querySelector('[data-builder-choose-setting]');
      if (settingButton) {
        settingButton.addEventListener('click', () => {
          location.assign(ringRoute());
        });
      }

      const viewCart = dialogContent.querySelector('[data-builder-view-cart]');
      if (viewCart) viewCart.addEventListener('click', () => location.assign(config.routes.cart));

      const continueButton = dialogContent.querySelector('[data-builder-continue]');
      if (continueButton) continueButton.addEventListener('click', () => dialog.close());

      const diamondOnly = dialogContent.querySelector('[data-builder-diamond-only]');
      if (diamondOnly) {
        diamondOnly.addEventListener('click', () => {
          clearState();
          dialog.close();
          progress.hidden = true;
        });
      }

      dialog.showModal();
      root.hidden = false;
    };

    const handleNivodaAdd = async (button) => {
      const before = cartBeforePointerDown ? await cartBeforePointerDown : await fetchCart();
      cartBeforePointerDown = null;
      const startingCount = before.item_count;
      const beforeQuantities = new Map(before.items.map((item) => [item.key, item.quantity]));
      let cart = before;

      for (let attempt = 0; attempt < 18; attempt += 1) {
        await new Promise((resolve) => window.setTimeout(resolve, 700));
        cart = await fetchCart();
        if (cart.item_count > startingCount) break;
      }

      if (cart.item_count <= startingCount) {
        report(config.text.diamondAddFailed);
        return;
      }

      const state = currentState();
      state.start = state.start || 'diamond';
      const addedItem = cart.items.find((item) => !beforeQuantities.has(item.key) || item.quantity > beforeQuantities.get(item.key));
      state.diamond = {
        ...state.diamond,
        ...getDiamondData(),
        key: addedItem && addedItem.key,
        variantId: addedItem && addedItem.variant_id
      };
      writeState(state);
      renderProgress();
      const currentUrl = location.href;
      window.setTimeout(() => {
        if (location.href === currentUrl && document.visibilityState === 'visible') openDiamondDialog(state);
      }, 1600);
      button.removeAttribute('aria-busy');
    };

    const setupDiamondPage = () => {
      const promoteDiamondDetailTitle = () => {
        document.querySelectorAll('h2.diamond-proxy-view-details-title').forEach((title) => {
          const heading = document.createElement('h1');
          Array.from(title.attributes).forEach((attribute) => heading.setAttribute(attribute.name, attribute.value));
          heading.innerHTML = title.innerHTML;
          title.replaceWith(heading);
        });

        if (document.querySelector('h1.diamond-proxy-view-details-title')) {
          document.querySelectorAll('h1.rte.homepage-sections--title').forEach((title) => {
            if (!/search (?:lab-grown|natural|fancy color) diamonds/i.test(title.textContent)) return;
            const heading = document.createElement('h2');
            Array.from(title.attributes).forEach((attribute) => heading.setAttribute(attribute.name, attribute.value));
            heading.innerHTML = title.innerHTML;
            title.replaceWith(heading);
          });
        }
      };

      const refreshDiamondPage = () => {
        promoteDiamondDetailTitle();
        if (rememberFancySearch()) renderProgress();
      };
      refreshDiamondPage();
      new MutationObserver(refreshDiamondPage).observe(document.body, { childList: true, subtree: true });

      if (isFancyDiamondPage) {
        window.addEventListener('pagehide', rememberFancySearch);
        document.addEventListener('click', (event) => {
          if (!event.target.closest('#nat-lab-toggle .nat-lab-item')) return;
          window.requestAnimationFrame(() => {
            if (rememberFancySearch()) renderProgress();
          });
        });
      }

      document.addEventListener('pointerdown', (event) => {
        const button = event.target.closest('button, [role="button"]');
        const app = button && button.closest('[id*="nivoda_connect_feed"]');
        if (app && /add to cart/i.test(button.textContent)) cartBeforePointerDown = fetchCart();
      }, true);

      document.addEventListener('click', (event) => {
        const button = event.target.closest('button, [role="button"]');
        const app = button && button.closest('[id*="nivoda_connect_feed"]');
        if (!app || !/add to cart/i.test(button.textContent)) return;
        const state = currentState();
        state.start = state.start || 'diamond';
        state.diamond = getDiamondData();
        writeState(state);
        renderProgress();
        button.setAttribute('aria-busy', 'true');
        handleNivodaAdd(button).catch(() => {
          button.removeAttribute('aria-busy');
          report(config.text.diamondAddFailed);
        });
      }, true);
    };

    root.querySelector('[data-osiris-builder-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    const initialize = async () => {
      try {
        await syncStateWithCart();
      } catch {
      }

      if (isRingProduct) {
        setupRingProduct();
        new MutationObserver(setupRingProduct).observe(document.body, { childList: true, subtree: true });
      }

      if (isDiamondPage) {
        const state = readState();
        if (!isFancyDiamondPage || !state.diamondType) state.diamondType = config.diamondType;
        state.diamondCollection = config.diamondCollection;
        if (!isFancyDiamondPage) delete state.diamondSearch;
        writeState(state);
        setupDiamondPage();
      }
      renderProgress();

      if (isCartPage) {
        window.setInterval(async () => {
          try {
            if (await syncStateWithCart()) renderProgress();
          } catch {
          }
        }, 2000);
      }
    };

    initialize();
  })();
  } catch(e) { console.error(e); }
})();

})();
